// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"0a475caa","70":"33cbbc15","71":"1b0b5a89","195":"9d88f076","293":"4c63abc0","349":"3e152aaa","360":"d220b864","419":"7f881d19","606":"7b0ff445","621":"663e3b8e","870":"50cf0988"}[chunkId] + ".chunk.js";
};